module.exports = __webpack_public_path__ + "img/medicine-management_3.fb5e9f11.png";